import { render, staticRenderFns } from "./GameSpeed.vue?vue&type=template&id=2283a9f3&scoped=true&"
import script from "./GameSpeed.vue?vue&type=script&lang=js&"
export * from "./GameSpeed.vue?vue&type=script&lang=js&"
import style0 from "./GameSpeed.vue?vue&type=style&index=0&id=2283a9f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283a9f3",
  null
  
)

export default component.exports